import client from './client';
import type {
  PulumiStack,
  PulumiResource,
  InfrastructureSummary,
  PaginatedResponse,
} from '@/types';

export interface StackListParams {
  cloud_provider?: string;
  status?: string;
  page?: number;
  page_size?: number;
}

export interface ResourceListParams {
  resource_type?: string;
  cloud_provider?: string;
  page?: number;
  page_size?: number;
}

export async function fetchStacks(params?: StackListParams) {
  const { data } = await client.get<PaginatedResponse<PulumiStack>>('/infrastructure/stacks', { params });
  return data;
}

export async function fetchStack(stackId: string) {
  const { data } = await client.get<PulumiStack>(`/infrastructure/stacks/${stackId}`);
  return data;
}

export async function fetchStackResources(
  stackId: string,
  params?: { resource_type?: string; page?: number; page_size?: number },
) {
  const { data } = await client.get<PaginatedResponse<PulumiResource>>(
    `/infrastructure/stacks/${stackId}/resources`,
    { params },
  );
  return data;
}

export async function fetchAllResources(params?: ResourceListParams) {
  const { data } = await client.get<PaginatedResponse<PulumiResource>>('/infrastructure/resources', {
    params,
  });
  return data;
}

export async function fetchInfrastructureSummary() {
  const { data } = await client.get<InfrastructureSummary>('/infrastructure/summary');
  return data;
}
